/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2020 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/


import React, { useContext } from 'react';
import asyncCallHandler from '../common/utils/AsyncCallHandler';
import {setItem, getItem} from '../common/utils/StorageManager';



import { ACTION_TYPES } from './ActionTypes';
import env from '../common/env';


export const fetchStudents = (token, url) => { 
    return (dispatch) => {
        return asyncCallHandler(env.STUDENT_END_POINT, env.STUDENT_FETCH_QUERY+ '?' + url, token).then(res => {
           
            dispatch({ type: ACTION_TYPES.FETCH_STUDENTS, payload: res.data })
        }).catch(err => {
            dispatch({ type: ACTION_TYPES.FETCH_STUDENTS, payload: err })
        });
    }

}

export const fetchStudentDetails = (id, token, params) => {
    let { courseId, groupId, schoolId } = params;
    return (dispatch) => {
        asyncCallHandler(env.STUDENT_END_POINT, `studentDetails?studentId=${id}&courseId=${courseId}&groupId=${groupId}&schoolId=${schoolId}`, token).then(res => {
            dispatch({ type: ACTION_TYPES.FETCH_STUDENT_DETAILS, payload: res.data })
        }).catch(err => {
            dispatch({ type: ACTION_TYPES.FETCH_STUDENT_DETAILS, payload: err })
        });
    }

}

export const fetchStudentAssessmentDetails = (id, token, params) => {
    let { courseId, groupId, schoolId, studentId, dateTaken} = params;
    return (dispatch) => {
        asyncCallHandler(env.STUDENT_END_POINT, `studentAssessmentDetails?studentId=${studentId}&courseId=${courseId}&groupId=${groupId}&schoolId=${schoolId}&assessmentId=${id}&examDate=${dateTaken}`, token).then(res => {
            dispatch({ type: ACTION_TYPES.FETCH_STUDENT_ASSESSMENT_DETAILS, payload: res.data })
        }).catch(err => {
            dispatch({ type: ACTION_TYPES.FETCH_STUDENT_ASSESSMENT_DETAILS, payload: err })
        });
    }

}



export const fetchStudentGroups = (id, token) => {

    let schoolId = getItem('userData').schoolId;
    return (dispatch) => {
        asyncCallHandler(env.STUDENT_END_POINT, `studentGroupCourseDetails?studentId=${id}&schoolId=${schoolId}`, token).then(res => {
            dispatch({ type: ACTION_TYPES.FETCH_STUDENT_GROUPS, payload: res.data })
        }).catch(err => {
            dispatch({ type: ACTION_TYPES.FETCH_STUDENT_GROUPS, payload: err })
        });
    }

}

export const fetchStudentBaselineInfo = (id, token) => {

    return (dispatch) => {
        asyncCallHandler(env.STUDENT_END_POINT, `studentDashboardBaseline?groupId=&schoolId=${id}`, token).then(res => {
            dispatch({ type: ACTION_TYPES.FETCH_STUDENT_BASELINE, payload: res.data })
        }).catch(err => {
            dispatch({ type: ACTION_TYPES.FETCH_STUDENT_BASELINE, payload: err })
        });
    }

}

